export default {
    choose: 'Διάλεξε πελάτη',
    chooseText: 'Άνοιξε μια πρόσφατη συνομιλία ή βρες έναν πελάτη με την αναζήτηση.',
    findAthlete: 'Εύρεση καρτέλας',
    back: 'Πίσω',
    noMore: 'Αρχή της συνομιλίας',
    today: 'Σήμερα',
    yesterday: 'Χθες',
    loadError: 'Δεν ήταν δυνατή η φόρτωση των μηνυμάτων.',
    retry: 'Δοκίμασε ξανά',
    typeHere: 'Γράψε ένα μήνυμα…',
    send: 'Αποστολή',
    unread: 'Μη αναγνωσμένο',
    recent: 'Πρόσφατες συνομιλίες',
    results: 'Αποτελέσματα',
    searchPlaceholder: 'Αναζήτηση πελάτη…',
    empty: {
        recent: {
            title: 'Δεν έχεις ακόμα συνομιλίες',
            subtitle: 'Βρες έναν πελάτη με την αναζήτηση και στείλε του το πρώτο μήνυμα.'
        },
        noMatch: {
            title: 'Δεν βρέθηκαν πελάτες',
            subtitle: 'Μπορείς να συνομιλήσεις μόνο με πελάτες που είναι συνδεδεμένοι μαζί σου στην εφαρμογή athlisis.'
        },
        messages: {
            title: 'Ξεκίνα τη συνομιλία',
            subtitle: 'Δεν υπάρχουν μηνύματα ακόμα. Γράψε το πρώτο στο πεδίο από κάτω.'
        }
    }
}
